// Background image functions
let _this = (module.exports = {
	ajaxLoad: function () {
		document.addEventListener('DOMContentLoaded', () => {
			const postsContainer = document.querySelector('#ajax-posts-container');
			const loadMoreButton = document.querySelector('#ajax-load-more');
			const filterButtons = document.querySelectorAll('.js-filter-tag');
			const filterCategory = document.querySelectorAll('.js-filter-category');
      
			if (!postsContainer || !loadMoreButton) {
				return;
			}
			let postType = postsContainer.dataset.postype
				? postsContainer.dataset.postype
				: 'post';
			let currentPage = 1;
			let currentTag = '';
			let currentCategory = '';
			let maxPages = 1;
			let isLoading = false;

			/**
			 * Fetch posts with AJAX.
			 *
			 * @param {number} page
			 * @param {string} tag
			 * @param {boolean} append
			 * @param {string} category
			 */
			const fetchPosts = async (
				page = 1,
				tag = '',
				append = false,
				category = '',
			) => {
				if (isLoading) {
					return;
				}
				isLoading = true;
				loadMoreButton.disabled = true;
				loadMoreButton.textContent = 'Učitavanje...';

				const formData = new FormData();
				formData.append('action', 'mbn_ajax_filter_posts');
				formData.append('nonce', mbnAjaxPosts.nonce);
				formData.append('page', String(page));
				formData.append('tag', tag);
				formData.append('category', category);
				formData.append('post_type', postType);

				try {
					const response = await fetch(mbnAjaxPosts.ajaxUrl, {
						method: 'POST',
						body: formData,
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error('AJAX request failed.');
					}

					if (append) {
						postsContainer.insertAdjacentHTML('beforeend', data.data.html);
					} else {
						postsContainer.innerHTML = data.data.html;
					}

					currentPage = data.data.page;
					maxPages = data.data.max_pages;

					postsContainer.dataset.page = currentPage; // Update the current page in the container's dataset
					postsContainer.dataset.maxpage = maxPages; // Update the current page in the container's dataset
          console.log(data);
          
					if (currentPage >= maxPages || !data.data.html.trim()) {
						loadMoreButton.style.display = 'none';
            loadMoreButton.classList.add('hide-btn')
					} else {
						loadMoreButton.style.display = 'inline-block';
            loadMoreButton.classList.remove('hide-btn')
					}

					const url = new URL(window.location.href);
					url.searchParams.set('te_tag', tag); // Adds or updates 'key'
					url.searchParams.set('te_page', page); // Adds or updates 'key'
					url.searchParams.set('te_category', currentCategory); // Adds or updates 'key'
					window.history.replaceState(null, '', url);
				} catch (error) {
					console.error(error);
				} finally {
					isLoading = false;
					loadMoreButton.disabled = false;
					loadMoreButton.textContent = 'UČITAJ JOŠ OBJAVA';
				}
			};

			// Initial load.
			// fetchPosts(1, currentTag, false);

			// Tag filter click.
			filterButtons.forEach((button) => {
				button.addEventListener('click', () => {
					if (button.classList.contains('is-active')) {
						button.classList.remove('is-active');
						currentTag = '';
					} else {
						filterButtons.forEach((item) => item.classList.remove('is-active'));
						button.classList.add('is-active');
						currentTag = button.dataset.tag || '';
					}
					currentPage = 1;
					maxPages = 1;

					fetchPosts(1, currentTag, false, currentCategory);
				});
			});
			filterCategory.forEach((select) => {
				select.addEventListener('change', () => {
					currentCategory = select.value || '';
					currentPage = 1;
					maxPages = 1;

					fetchPosts(1, currentTag, false, currentCategory);
				});
			});

			// Load more click.
			loadMoreButton.addEventListener('click', () => {
				if (
					parseInt(postsContainer.dataset.page) <
					parseInt(postsContainer.dataset.maxpage)
				) {
					fetchPosts(
						parseInt(postsContainer.dataset.page) + 1,
						currentTag,
						true,
						currentCategory,
					);
				}
			});
		});
	},
	init: function () {
		_this.ajaxLoad();
	},
});
